export enum UploadStatusEnum {
  Failed = 1,
  Done = 2,
}
